<template>
  <div :class="`share-buttons share-buttons--${position}`">

    <a class="share-button" :href="linkedInShareUrl" rel="nofollow" target="_blank">
      <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 64 64"><path d="M53.25 0h-42.5C4.838 0 0 4.838 0 10.75v42.5C0 59.163 4.838 64 10.75 64h42.5C59.163 64 64 59.163 64 53.25v-42.5C64 4.838 59.163 0 53.25 0zM24 52h-8V24h8v28zm-4-32c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm32 32h-8V36c0-2.21-1.79-4-4-4s-4 1.79-4 4v16h-8V24h8v4.967C37.65 26.7 40.172 24 43 24c4.97 0 9 4.477 9 10v18z"></path></svg>
    </a>

    <a class="share-button" :href="twitterShareUrl" rel="nofollow" target="_blank">
      <svg xmlns="http://www.w3.org/2000/svg" height="40" viewBox="0 0 56.7 56.7" width="40"><path d="M52.8 15.1c-1.8 0.8-3.8 1.3-5.8 1.6 2.1-1.2 3.7-3.2 4.4-5.6 -2 1.2-4.1 2-6.4 2.5 -1.8-2-4.5-3.2-7.4-3.2 -5.6 0-10.1 4.5-10.1 10.1 0 0.8 0.1 1.6 0.3 2.3 -8.4-0.4-15.8-4.4-20.8-10.6 -0.9 1.5-1.4 3.2-1.4 5.1 0 3.5 1.8 6.6 4.5 8.4 -1.7-0.1-3.2-0.5-4.6-1.3 0 0 0 0.1 0 0.1 0 4.9 3.5 9 8.1 9.9 -0.8 0.2-1.7 0.4-2.7 0.4 -0.7 0-1.3-0.1-1.9-0.2 1.3 4 5 6.9 9.4 7 -3.5 2.7-7.8 4.3-12.6 4.3 -0.8 0-1.6 0-2.4-0.1 4.5 2.9 9.8 4.5 15.5 4.5 18.6 0 28.8-15.4 28.8-28.8 0-0.4 0-0.9 0-1.3C49.8 18.9 51.5 17.1 52.8 15.1z"/></svg>
    </a>

    <a class="share-button share-button--facebook" :href="facebookShareURL" @click="facebookShareClick()" rel="nofollow" target="_blank">
      <span class="share-button__label">Share on Facebook</span>
      <svg enable-background="new 0 0 40 40" height="40px" id="Layer_1" version="1.1" viewBox="0 0 56.693 56.693" width="56.693px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M40.43,21.739h-7.645v-5.014c0-1.883,1.248-2.322,2.127-2.322c0.877,0,5.395,0,5.395,0V6.125l-7.43-0.029  c-8.248,0-10.125,6.174-10.125,10.125v5.518h-4.77v8.53h4.77c0,10.947,0,24.137,0,24.137h10.033c0,0,0-13.32,0-24.137h6.77  L40.43,21.739z"/></svg>
    </a>
    
  </div>
</template>

<script>
export default {
  name: 'content-share',
  props: [
    'title',
    'position'
  ],
  computed: {
    encodedUrl () {
      return encodeURIComponent(location.href)
    },
    encodedTitle () {
      return encodeURIComponent(this.title)
    },
    facebookShareURL () {
      return `http://www.facebook.com/share.php?u=${this.encodedUrl}&t=${this.encodedTitle}`
    },
    twitterShareUrl () {
      let twitterUser = 'microsystems'
      return `https://twitter.com/share?url=${this.encodedUrl}&via=${twitterUser}&text=${this.encodedTitle}`
    },
    linkedInShareUrl () {
      return `https://www.linkedin.com/shareArticle?mini=true&url=${this.encodedUrl}&title=${this.encodedTitle}`
    }
  },
  methods: {
    facebookShareClick () {
      let shareUrl = `http://www.facebook.com/sharer.php?u=${this.encodedUrl}&t=${this.encodedTitle}`
      window.open(shareUrl, 'sharer', 'toolbar=0,status=0,width=626,height=436')
      return false
    }
  }
}
</script>
<style lang="scss" scoped>
// $color-facebook: #306199 !default;
// $color-linkedin: #007bb6 !default;
// $color-twitter: #26c4f1 !default;
// $color-googleplus: #e93f2e !default;

  .share-buttons {
    text-align: center;
    display: flex;
    justify-content: space-between;
    max-width: 180px;
    margin-left: auto;
    margin-right: auto;
  }

  .share-buttons--top {
    margin-top: 2rem;
    margin-bottom: 1rem;

    @media (min-width: $breakpoint-lg) {
      margin-top: 4rem;
      margin-bottom: 2rem;
    }
  }

  .share-buttons--bottom {
    margim-top: 2rem;
    margin-bottom: 4rem;
  }

  .share-button {
    border: 2px solid #eee;
    border-radius: 50%;
    display: inline-block;
    height: 50px;
    line-height: 45px;
    transition: background-color, color, .2s ease-in-out;
    width: 50px;
    will-change: background-color, color;

    &:hover {
      background-color: $management;
    }
  }

  .share-button svg {
    display: inline-block;
    height: 25px;
    width: 25px;
    vertical-align: middle;
  }

  .share-button:hover svg {
    path {
      fill: #fff;
    }
  }

  .share-button__label {
    display: none;
  }

  .share-button:hover {
    .leadership & {
      background-color: $leadership;
      border-color: $leadership;
    }

    .legal-tech & {
      background-color: $legal-tech;
      border-color: $legal-tech;
    }

    .legal-market & {
      background-color: $legal-market;
      border-color: $legal-market;
    }

    .management & {
      background-color: $management;
      border-color: $management;
    }
  }
</style>



// WEBPACK FOOTER //
// Share.vue?0666daaf